module.exports = __webpack_public_path__ + "static/media/sanitizermask.46b7c3ae.jpg";